module.exports = __webpack_public_path__ + "img/megaphone.c047c3ca.png";